module.exports = __webpack_public_path__ + "media/get-started/lines2-679c9b54.svg";